// extracted by mini-css-extract-plugin
module.exports = {"button":"Rotation_button__12ftZ","infoText":"Rotation_infoText__30Nnu"};